export const state = () => ({
  items: [],
  page: 1,
  perPage: null,
  total: null,
  subscription: {},
});

export const mutations = {
  SET_ITEMS(state, payload) {
    state.items = payload;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_PER_PAGE(state, limit) {
    state.perPage = limit;
  },
  UPDATE_ITEMS(state, payload) {
    const copyItems = [...state.items];
    const index = copyItems.findIndex(item => item.id === payload.id);
    copyItems[index] = payload;

    state.items = copyItems;
  },
  SET_SUBSCRIPTION(state, payload) {
    state.subscription = payload;
  },
};

export const actions = {
  async getPage({state, commit}, options = {}) {
    options = {
      page: state.page,
      ...options,
    };

    const params = Object.entries(options).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&');
    const url = `/admin/abonnementen?${params}`;

    try {
      const {data} = await this.$axios.get(url);

      commit('SET_ITEMS', data.data);
      commit('SET_TOTAL', parseInt(data.meta.total, 10));
      commit('SET_PER_PAGE', parseInt(data.meta.per_page, 10));
    } catch (e) {
      console.error(e);
    }
  },
  async getSingle({state, commit}, id) {
    try {
      const {data} = await this.$axios.get(`/admin/abonnementen/${id}`);
      commit('SET_SUBSCRIPTION', data.data);
    } catch (e) {
      console.error(e);
    }
  },
  async cancelSubscription({state, commit}, options = {subscription: {}, type: 'period_end'}) {
    const {data} = await this.$axios.post(`/admin/abonnementen/${options.subscription.id}`, {
      cancellation_period: options.type,
    });
    commit('SET_SUBSCRIPTION', data.data);
  },
  async changeBillingCycle({state, commit}, options = {subscription: {}, date: this.$moment()}) {
    const {data} = await this.$axios.post(`/admin/abonnementen/change-billing-cycle/${options.subscription.id}`, {
      billing_anchor: options.date.format('DD-MM-YYYY'),
    });
    commit('SET_SUBSCRIPTION', data.data);
  },
};
